import { ref, watch } from '@vue/composition-api';

const KEY_PREFIX = 'table:perPage:';

function readStored(key) {
  try {
    const n = parseInt(localStorage.getItem(KEY_PREFIX + key), 10);
    return Number.isInteger(n) && n > 0 ? n : null;
  } catch (e) {
    return null;
  }
}

/**
 * A `perPage` ref that persists the user's page-count selection to localStorage,
 * scoped per table by `key`.
 *
 * Precedence for the initial value: explicit `override` (e.g. a URL query param)
 * > stored value > `defaultValue`.
 *
 * @param {string} key           Stable, table-unique key (e.g. 'usersList').
 * @param {number} defaultValue  Fallback when nothing is stored. Defaults to 10.
 * @param {number|null} override Value that wins over the stored one when truthy.
 * @returns {import('@vue/composition-api').Ref<number>}
 */
export default function usePersistedPerPage(key, defaultValue = 10, override = null) {
  const perPage = ref(override || readStored(key) || defaultValue);
  watch(perPage, (val) => {
    try {
      localStorage.setItem(KEY_PREFIX + key, String(val));
    } catch (e) {
      /* private mode / quota — ignore */
    }
  });
  return perPage;
}
